import {
  MPageContainer,
  MSettingsPageHeader,
} from '../../../components/Monetize';

const Subscriptions = () => {
  const test = '';
  return (
    <MPageContainer alignItems="stretch">
      <MSettingsPageHeader title="Subscriptions" />
    </MPageContainer>
  );
};

export default Subscriptions;
